"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    class: "align-center flex-gap",
    style: { "color": "#5F6B71" }
};
const _hoisted_2 = {
    key: 0,
    href: "https://7760438.hs-sites-na2.com/knowledge/promptnotes",
    class: "header-question-mark-link",
    target: "_blank"
};
const _hoisted_3 = { class: "content-wrapper" };
const _hoisted_4 = {
    key: 0,
    class: "auto-ai-message"
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "btn-wrapper" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("../../../vue/Modal.vue"));
const AlertModal_vue_1 = __importDefault(require("../../../vue/AlertModal.vue"));
const AutoAIRoles_vue_1 = __importDefault(require("./components/AutoAIRoles.vue"));
const OpenAIIcon_vue_1 = __importDefault(require("../../assets/icons/OpenAIIcon.vue"));
const AutoAIShiftGenerator_vue_1 = __importDefault(require("./components/AutoAIShiftGenerator.vue"));
const AutoAIScheduleOptions_vue_1 = __importDefault(require("./components/AutoAIScheduleOptions.vue"));
const AutoAIConfirmation_vue_1 = __importDefault(require("./components/AutoAIConfirmation.vue"));
const errors_1 = __importDefault(require("../../../js/errors"));
const common_1 = require("../../../common/common");
const autoAIRequest_1 = require("../../../requests/autoAIRequest");
const autoAI_1 = require("./model/autoAI");
const provider_1 = require("../../../provider/provider");
const autoai_poll_1 = require("./autoai_poll");
const summary_lib_1 = require("../../../js/summary_lib");
const periodTypes_1 = __importDefault(require("../../../table/v1/periodTypes"));
const autoAIStorage_1 = require("../../../storage/autoAIStorage");
const QuestionMarkCircleIcon_vue_1 = __importDefault(require("../../assets/icons/QuestionMarkCircleIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIModal',
    setup(__props) {
        const alertModal = (0, vue_3.ref)(null);
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const summaryTablePresenter = (0, vue_3.inject)(provider_1.summaryTablePresenterInjectKey);
        const showConfirmation = (0, vue_3.ref)(false);
        const loadingClass = (0, vue_3.computed)(() => {
            return viewModel?.value.isLoading ? 'loading' : '';
        });
        const disabledClass = (0, vue_3.computed)(() => {
            const numOfSelectedRoles = viewModel?.value.checkedRoles.length || 0;
            return numOfSelectedRoles === 0 ? 'disabled-btn' : '';
        });
        const modalName = (0, vue_3.computed)(() => {
            return "auto-modal";
        });
        const title = (0, vue_3.computed)(() => {
            const vm = viewModel?.value;
            if (vm?.editExisting) {
                return 'AIシフト編集';
            }
            if (vm?.showRoles) {
                return '業務を選択してください';
            }
            return 'AIシフト作成';
        });
        const loadingOrDoneMessage = (0, vue_3.computed)(() => {
            const loadingMessage = 'シフトを作成中です。\n 複雑なシフトは作成に時間がかかる場合があります。';
            const successMessage = 'シフトの作成が完了しました。';
            return viewModel?.value.isDone ? successMessage : loadingMessage;
        });
        const dateRange = (0, vue_3.computed)(() => {
            if (!viewModel?.value) {
                return;
            }
            return {
                startStr: (0, common_1.yearMonthDateString)(viewModel.value.dateRange.start, "Asia/Tokyo").replace(/-/g, ""),
                endStr: (0, common_1.yearMonthDateString)(viewModel.value.dateRange.end, "Asia/Tokyo").replace(/-/g, ""),
            };
        });
        const showRoles = (0, vue_3.computed)(() => {
            return viewModel?.value ? viewModel.value.showRoles : false;
        });
        const showCreateEditOptions = (0, vue_3.computed)(() => {
            return viewModel?.value ? viewModel.value.showCreateEditOptions : false;
        });
        const loadingOrDone = (0, vue_3.computed)(() => {
            return viewModel?.value.isLoading || viewModel?.value.isDone || false;
        });
        const notesJapanese = (0, vue_3.computed)(() => {
            return viewModel?.value.notesJapanese || "";
        });
        const isVisible = (0, vue_3.computed)(() => {
            return viewModel?.value.isVisible || false;
        });
        const selectedRoles = (0, vue_3.computed)(() => {
            const vm = viewModel?.value;
            if (!vm || vm.editExisting) {
                return [];
            }
            const selectedRoleIDs = new Set(vm.checkedRoles);
            return vm.roles.filter(role => selectedRoleIDs.has(role.getOriginalId()));
        });
        function closeModal() {
            if (viewModel?.value.isDone && viewModel.value.reloadOnDone) {
                window.location.reload();
            }
            presenter?.setIsVisible(false);
            presenter?.clear();
            showConfirmation.value = false;
        }
        function openModal() {
            presenter?.setIsVisible(true);
        }
        function onCancel() {
            closeModal();
        }
        // Go to shift generator
        function next() {
            presenter?.showShiftGenerator();
        }
        function handleCreateEditOptionsNext() {
            if (viewModel?.value.editExisting) {
                // If editing existing, skip roles selection and go to shift generator
                presenter?.showShiftGenerator();
                return;
            }
            // Go to roles selection
            presenter?.showRolesSelection();
        }
        function sendAutoAICreateEvent() {
            if (!("gtag" in window) || typeof window.gtag !== "function") {
                return;
            }
            // Send Google Analytics event to track AI usage
            window.gtag('event', 'auto_ai_create', {
                provider: viewModel?.value?.provider || 'unknown',
                group_id: String(viewModel?.value?.groupId || 0),
                branch_id: String(viewModel?.value?.branchId || 0),
            });
        }
        function onConfirm() {
            if (!viewModel?.value.roles?.length) {
                return closeModal();
            }
            showConfirmation.value = true;
        }
        function goBackToGenerator() {
            showConfirmation.value = false;
        }
        function confirmAutoCreation() {
            submitAuto();
        }
        function getSelectedTags() {
            const selectedTags = [];
            const tags = viewModel?.value.tags;
            if (!tags) {
                return "";
            }
            tags.forEach(t => {
                if (t.selected) {
                    selectedTags.push(t.tag);
                }
            });
            return selectedTags.join(",");
        }
        function setTaskDone(notesJapanese) {
            presenter?.setTaskDone(true, notesJapanese);
            presenter?.setIsVisible(true);
        }
        async function submitAuto() {
            if (!viewModel?.value || viewModel?.value.isLoading || !dateRange.value) {
                return;
            }
            presenter?.setIsLoading(true);
            const instructions = viewModel.value.instructions.trim();
            const userId = viewModel.value.userId;
            const data = {
                list: viewModel.value.timePeriodType,
                date: viewModel.value.activeDate,
                until: viewModel.value.until,
                tags: getSelectedTags(),
                autoSel: viewModel.value.checkedRoles.join(','),
                instructions,
                provider: viewModel.value.provider,
                isEditExisting: viewModel.value.editExisting,
                excludedDates: summaryTablePresenter?.getScheduleLockedDates() ?? [],
            };
            // For DWS, include role ids selected in the tag/role filter modal
            if (viewModel.value.timePeriodType === periodTypes_1.default.DAY) {
                data.roleIds = viewModel.value.filteredRoleIds;
            }
            if (viewModel.value.sendSkills) {
                data.sendSkills = true;
            }
            if (viewModel.value.sendODays) {
                data.sendODays = true;
            }
            try {
                await (0, autoAIRequest_1.autoAIPostRequest)(viewModel.value.branchId, userId, data);
                (0, autoAIStorage_1.saveAutoAISettings)({
                    provider: viewModel.value.provider,
                    sendSkills: viewModel.value.sendSkills,
                    sendODays: viewModel.value.sendODays,
                });
                sendAutoAICreateEvent();
                if (instructions) {
                    await savePromptInStorage(instructions);
                }
                const dates = dateRange.value;
                // Start polling tasks for start/end range
                (0, autoai_poll_1.startAutoAIPolling)(userId, viewModel.value.branchId, viewModel.value.timePeriodType, dates.startStr, dates.endStr, setTaskDone);
            }
            catch (err) {
                alertModal.value?.alert(errors_1.default.AUTOAI.CREATE, true);
            }
            finally {
                presenter?.setIntructions("");
            }
        }
        async function savePromptInStorage(instructions) {
            if (!viewModel?.value) {
                return;
            }
            if (viewModel?.value.selectedPromptId) {
                const selectedPrompt = viewModel.value.promptHistory.find(r => r.id === viewModel.value.selectedPromptId);
                if (selectedPrompt && selectedPrompt.message === instructions.trim()) {
                    // If message was unchanged, update the date of the existing prompt
                    const updated = await (0, autoAIStorage_1.updateAutoAIPrompt)(selectedPrompt, viewModel.value.userId, viewModel.value.branchId);
                    presenter?.updatePromptHistory(updated);
                    return;
                }
            }
            // Save as new if its a new prompt or modified message
            const saved = await (0, autoAIStorage_1.saveAutoAIPrompt)(viewModel.value.userId, viewModel.value.branchId, instructions);
            presenter?.addPromptHistory({ id: saved.id, date: saved.date, message: instructions });
        }
        async function initAutoAIPolling() {
            if (!viewModel?.value || !dateRange.value) {
                return;
            }
            const userId = viewModel.value.userId;
            const branchId = viewModel.value.branchId;
            const dates = dateRange.value;
            // If the task is already done, don't reload or start polling
            const res = await (0, autoai_poll_1.getAutoAITaskResponse)(userId, branchId, viewModel.value.timePeriodType, dates.startStr, dates.endStr);
            if (res.state === undefined) {
                return;
            }
            if (res.stale) {
                (0, summary_lib_1.openAlertModal)(errors_1.default.AUTOAI.CREATE);
                return;
            }
            if (res.state === autoAI_1.TaskState.Done) {
                presenter?.setReloadOnDone(false);
                presenter?.setTaskDone(true, res.notesJapanese);
                presenter?.setIsVisible(true);
                (0, autoai_poll_1.clearAutoAITask)();
                return;
            }
            (0, autoai_poll_1.disableAutoAIBtn)(true);
            (0, autoai_poll_1.startAutoAIPolling)(userId, branchId, viewModel.value.timePeriodType, dates.startStr, dates.endStr, setTaskDone);
        }
        (0, vue_3.onMounted)(async () => {
            await initAutoAIPolling();
            if (!viewModel?.value) {
                return;
            }
            const history = await (0, autoAIStorage_1.getAutoAIPrompts)(viewModel.value.userId, viewModel.value.branchId);
            presenter?.setPromptHistory(history);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createCommentVNode)(" Auto AI button in summary footer dropdown "),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#auto-ai-modal-btn" }, [
                    (0, vue_2.createElementVNode)("button", {
                        class: "excel-link-btn excel btn delete-btn",
                        onClick: openModal
                    }, [
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("span", { class: "pro-label beta-label" }, null, -1 /* CACHED */)),
                        (0, vue_2.createVNode)(OpenAIIcon_vue_1.default),
                        _cache[4] || (_cache[4] = (0, vue_2.createTextVNode)(" AI ", -1 /* CACHED */))
                    ])
                ])),
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (isVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                        key: 0,
                        "modal-name": modalName.value,
                        onCloseModal: closeModal,
                        onConfirm: onConfirm,
                        onCancel: onCancel,
                        "has-title-divider": true,
                        "has-footer-divider": true
                    }, {
                        "header-title": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                (0, vue_2.createVNode)(OpenAIIcon_vue_1.default),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(title.value) + " ", 1 /* TEXT */),
                                (!(0, vue_2.unref)(viewModel)?.showRoles && !showConfirmation.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", _hoisted_2, [
                                        (0, vue_2.createVNode)(QuestionMarkCircleIcon_vue_1.default)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("v-if", true)
                            ])
                        ]),
                        content: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createCommentVNode)(" Loading or done message "),
                                (loadingOrDone.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(loadingOrDoneMessage.value) + " ", 1 /* TEXT */),
                                        (notesJapanese.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)(notesJapanese.value), 1 /* TEXT */))
                                            : (0, vue_2.createCommentVNode)("v-if", true)
                                    ]))
                                    : (showCreateEditOptions.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                            (0, vue_2.createCommentVNode)(" Create/Edit Options "),
                                            (0, vue_2.createVNode)(AutoAIScheduleOptions_vue_1.default)
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                        : (showRoles.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 2 }, [
                                                (0, vue_2.createCommentVNode)(" Roles list "),
                                                (0, vue_2.createVNode)(AutoAIRoles_vue_1.default)
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            : (showConfirmation.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 3 }, [
                                                    (0, vue_2.createCommentVNode)(" Submission confirmation "),
                                                    (0, vue_2.createVNode)(AutoAIConfirmation_vue_1.default, {
                                                        "selected-roles": selectedRoles.value,
                                                        "show-roles": !(0, vue_2.unref)(viewModel)?.editExisting,
                                                        instructions: (0, vue_2.unref)(viewModel)?.instructions ?? '',
                                                        "send-skills": (0, vue_2.unref)(viewModel)?.sendSkills ?? false,
                                                        "send-o-days": (0, vue_2.unref)(viewModel)?.sendODays ?? false
                                                    }, null, 8 /* PROPS */, ["selected-roles", "show-roles", "instructions", "send-skills", "send-o-days"])
                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 4 }, [
                                                    (0, vue_2.createCommentVNode)(" Shift generator content "),
                                                    (0, vue_2.createVNode)(AutoAIShiftGenerator_vue_1.default)
                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            ])
                        ]),
                        "footer-btn": (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (loadingOrDone.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        key: 0,
                                        class: "oplus-modal-btn oplus-confirm-btn",
                                        onClick: closeModal
                                    }, "閉じる"))
                                    : (showCreateEditOptions.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 1,
                                            class: "oplus-modal-btn oplus-alt-confirm-btn col-ml-auto",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (handleCreateEditOptionsNext()))
                                        }, "次へ"))
                                        : (showRoles.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                key: 2,
                                                class: (0, vue_2.normalizeClass)([disabledClass.value, "oplus-modal-btn oplus-alt-confirm-btn col-ml-auto"]),
                                                onClick: _cache[1] || (_cache[1] = ($event) => (next()))
                                            }, "次へ", 2 /* CLASS */))
                                            : (showConfirmation.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 3 }, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: "oplus-modal-btn oplus-cancel-btn",
                                                        onClick: goBackToGenerator
                                                    }, "戻る"),
                                                    (0, vue_2.createElementVNode)("button", {
                                                        class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-alt-confirm-btn col-ml-auto"]),
                                                        onClick: confirmAutoCreation
                                                    }, "確認", 2 /* CLASS */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                    key: 4,
                                                    class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-alt-confirm-btn col-ml-auto"]),
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (onConfirm()))
                                                }, "登録", 2 /* CLASS */))
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modal-name"]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
